export default __webpack_public_path__ + "static/media/FinancialReport.47718957.png";